const ChallengeCompletePlatinum = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={166}
    height={166}
    viewBox='0 0 166 166'
  >
    <defs>
      <path id='a' d='M0 164h164V0H0z' />
      <path
        id='c'
        d='M.03.01v14.228h85.366v-5.64H10.652A1.802 1.802 0 0 1 8.85 6.797V.01H.03z'
      />
      <linearGradient
        id='d'
        x1='20.833%'
        x2='74.136%'
        y1='224.993%'
        y2='-94.81%'
      >
        <stop offset='0%' stopColor='#959EB2' />
        <stop offset='100%' stopColor='#D1D4E2' />
      </linearGradient>
      <path
        id='f'
        d='M.019.16v11.383H56.93V6.137H10.493A1.802 1.802 0 0 1 8.69 4.335V.16H.019z'
      />
      <linearGradient id='g' x1='20%' x2='74.75%' y1='199.995%' y2='-73.746%'>
        <stop offset='0%' stopColor='#959EB2' />
        <stop offset='100%' stopColor='#D1D4E2' />
      </linearGradient>
      <path id='i' d='M.076.067h5.69v19.918H.077z' />
      <linearGradient
        id='j'
        x1='138.282%'
        x2='-38.278%'
        y1='6.313%'
        y2='93.685%'
      >
        <stop offset='0%' stopColor='#959EB2' />
        <stop offset='100%' stopColor='#D1D4E2' />
      </linearGradient>
      <path
        id='l'
        d='M.019.143v31.3C.019 47.151 12.767 59.9 28.475 59.9c2.16 0 4.262-.242 6.283-.697-12.688-2.862-22.175-14.21-22.175-27.76V.143H.02z'
      />
      <linearGradient id='m' x1='5.495%' x2='85.587%' y1='75.289%' y2='28.729%'>
        <stop offset='0%' stopColor='#959EB2' />
        <stop offset='100%' stopColor='#D1D4E2' />
      </linearGradient>
      <path
        id='o'
        d='M.16.172v22.763c6.316 0 11.67-4.112 13.528-9.807a14.145 14.145 0 0 1-8.12 2.546V.172H.16z'
      />
      <linearGradient
        id='p'
        x1='-31.177%'
        x2='72.946%'
        y1='81.473%'
        y2='19.597%'
      >
        <stop offset='0%' stopColor='#959EB2' />
        <stop offset='100%' stopColor='#D1D4E2' />
      </linearGradient>
      <path
        id='r'
        d='M3.633.17A3.604 3.604 0 0 0 .028 3.776v4.932c0 7.858 6.37 14.228 14.228 14.228V.171H3.633zm1.802 8.537v-3.13H8.85v10.096a8.81 8.81 0 0 1-3.415-6.966z'
      />
      <linearGradient id='s' x1='129.645%' x2='7.065%' y1='81.472%' y2='4.86%'>
        <stop offset='0%' stopColor='#959EB2' />
        <stop offset='100%' stopColor='#D1D4E2' />
      </linearGradient>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(1 1)'>
        <path
          fill='#FFF'
          d='M163.099 82c0 44.79-36.49 81.099-81.28 81.099C37.03 163.099.902 126.789.902 82 .901 37.21 37.031.901 81.82.901c44.79 0 81.279 36.31 81.279 81.099'
        />
        <path
          stroke='#E3E6E8'
          strokeWidth={2}
          d='M163.099 82c0 44.79-36.49 81.099-81.28 81.099C37.03 163.099.902 126.789.902 82 .901 37.21 37.031.901 81.82.901c44.79 0 81.279 36.31 81.279 81.099z'
        />
        <mask id='b' fill='#fff'>
          <use xlinkHref='#a' />
        </mask>
        <path
          fill='#FFF'
          d='M39.316 136.066h85.368v-14.228H39.316z'
          mask='url(#b)'
        />
      </g>
      <g transform='translate(40.288 122.829)'>
        <mask id='e' fill='#fff'>
          <use xlinkHref='#c' />
        </mask>
        <path
          fill='url(#d)'
          d='M.03.01v14.228h85.366v-5.64H10.652A1.802 1.802 0 0 1 8.85 6.797V.01H.03z'
          mask='url(#e)'
        />
      </g>
      <path fill='#FFF' d='M54.544 122.838h56.912v-11.382H54.544z' />
      <g transform='translate(54.525 111.295)'>
        <mask id='h' fill='#fff'>
          <use xlinkHref='#f' />
        </mask>
        <path
          fill='url(#g)'
          d='M.019.16v11.383H56.93V6.137H10.493A1.802 1.802 0 0 1 8.69 4.335V.16H.019z'
          mask='url(#h)'
        />
      </g>
      <path fill='#FFF' d='M77.309 111.456H88.69v-19.92H77.31z' />
      <g transform='translate(77.233 91.47)'>
        <mask id='k' fill='#fff'>
          <use xlinkHref='#i' />
        </mask>
        <path fill='url(#j)' d='M.076 19.985h5.69V.067H.077z' mask='url(#k)' />
      </g>
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M40.316 137.066h85.368v-14.228H40.316zM54.544 122.838h56.912v-11.382H54.544z'
      />
      <path
        fill='#FFF'
        d='M100.72 31.78h10.736V63.08c0 7.854-3.187 14.968-8.338 20.118-5.15 5.15-12.264 8.338-20.118 8.338-15.708 0-28.456-12.749-28.456-28.456V31.78h33.49'
      />
      <g transform='translate(54.525 31.637)'>
        <mask id='n' fill='#fff'>
          <use xlinkHref='#l' />
        </mask>
        <path
          fill='url(#m)'
          d='M.019.143v31.3C.019 47.151 12.767 59.9 28.475 59.9c2.16 0 4.262-.242 6.283-.697-12.688-2.862-22.175-14.21-22.175-27.76V.143H.02z'
          mask='url(#n)'
        />
      </g>
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M77.309 111.456H88.69v-19.92H77.31z'
      />
      <path
        fill='#FF8887'
        d='M88.691 43.829V63.08l5.691-5.691 5.691 5.691V43.825z'
      />
      <path fill='#EB7170' d='M94.382 57.39l5.691 5.69V43.826l-5.69.002z' />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M88.691 43.829V63.08l5.691-5.691 5.691 5.691V43.825'
      />
      <path
        fill='#FFD01D'
        d='M94.382 28.934a8.537 8.537 0 1 0 8.537 8.537 8.537 8.537 0 0 0-8.537-8.537'
      />
      <path
        fill='#EAB800'
        d='M94.382 28.934v17.074a8.537 8.537 0 0 0 0-17.073'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M94.382 28.934a8.537 8.537 0 1 0 8.537 8.537 8.537 8.537 0 0 0-8.537-8.537z'
      />
      <path
        fill='#FFF'
        d='M122.08 43.162h-10.624v22.764c7.858 0 14.228-6.37 14.228-14.227v-4.933a3.604 3.604 0 0 0-3.605-3.604m-1.802 5.407v3.13a8.81 8.81 0 0 1-3.415 6.965V48.57h3.415'
      />
      <g transform='translate(111.295 42.991)'>
        <mask id='q' fill='#fff'>
          <use xlinkHref='#o' />
        </mask>
        <path
          fill='url(#p)'
          d='M.16.172v22.763c6.316 0 11.67-4.112 13.528-9.807a14.145 14.145 0 0 1-8.12 2.546V.172H.16z'
          mask='url(#q)'
        />
      </g>
      <g transform='translate(40.288 42.991)'>
        <mask id='t' fill='#fff'>
          <use xlinkHref='#r' />
        </mask>
        <path
          fill='url(#s)'
          d='M3.633.17A3.604 3.604 0 0 0 .028 3.776v4.932c0 7.858 6.37 14.228 14.228 14.228V.171H3.633zm1.802 8.537v-3.13H8.85v10.096a8.81 8.81 0 0 1-3.415-6.966z'
          mask='url(#t)'
        />
      </g>
      <g>
        <path
          fill='#FFF'
          d='M116.862 48.57v10.095a8.816 8.816 0 0 0 3.415-6.967v-3.129h-3.415zm0 0v10.095a8.816 8.816 0 0 0 3.415-6.967v-3.129h-3.415z'
        />
        <path
          stroke='#424547'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M122.08 43.162h-10.624v22.764c7.858 0 14.228-6.37 14.228-14.227v-4.933a3.604 3.604 0 0 0-3.605-3.604zm-1.803 5.407v3.13a8.81 8.81 0 0 1-3.415 6.965V48.57h3.415zM43.92 43.162a3.604 3.604 0 0 0-3.604 3.604V51.7c0 7.858 6.37 14.227 14.228 14.228V43.162H43.921zm1.803 5.407h3.415v10.095a8.81 8.81 0 0 1-3.415-6.965v-3.13zM100.72 31.78h10.736V63.08c0 7.854-3.187 14.968-8.338 20.118-5.15 5.15-12.264 8.338-20.118 8.338-15.708 0-28.456-12.749-28.456-28.456V31.78h33.49'
        />
      </g>
    </g>
  </svg>
);

export default ChallengeCompletePlatinum;
